import get from 'lodash/get';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {
  useGetMessagesQuery,
  useCreateMessageMutation
} from '../../redux/services/messageApi';
import useError from '../../hooks/useError';
import useUser from '../../hooks/useUser';
import AppDashboard from '../AppDashboard';
import ListMessagesScreen from '../../components/messages/ListMessagesScreen';

const ListMessagesPage = props => {
  // const [filter, setFilter] = useState({});
  const [scheduleDialogIsOpen, setScheduleDialogIsOpen] = useState(false);
  const user = useUser();
  const navigate = useNavigate();
  const errors = useError();
  const messagesQuery = useGetMessagesQuery({read_by_me: true}, {pollingInterval: 60000});
  const unreadMessagesQuery = useGetMessagesQuery(
    {is_read: false, user_to_id: user?.id},
    {skip: !user, pollingInterval: 60000}
  );
  const childProps = {
    ...props,
    messages: (get(messagesQuery, 'data.data') || []),
    unreadMessages: (get(unreadMessagesQuery, 'data.data') || []),
    unreadCount: unreadMessagesQuery?.data?.count || 0,
    user,
    loading: messagesQuery.isLoading || !user,
    isPatient: user?.is_patient,
    onViewPatientProfile: (
      user?.is_provider
      ? id => navigate(`/providers/patients/view/${id}`)
      : () => (true)
    ),
    setScheduleDialogIsOpen,
    scheduleDialogIsOpen,
  };
  return (
    <AppDashboard
      title={'Messages'}
      loading={childProps.loading}
      hasNoData={!childProps.loading && !childProps.messages}
    >
      <ListMessagesScreen {...childProps} />
    </AppDashboard>
  );
};

export default ListMessagesPage;
